const {
    mapLineItemsToSalesOrderDetailLineItems,
    mapShippingToSalesOrderDetailShipping,
    mapToOrderTotals,
    mapToSalesOrderPayments,
    mapMessagesToSalesOrder
} = require('./mappings');

const toSalesOrderResponse = (order) => {
    return {
        SalesOrderDetail: {
            OrderAction: order.action,
            SoldToMemberID: order.soldToMemberId,
            SalesOffice: order.salesOffice,
            OrderID: order.orderId,
            ...(order.adr && order.adr.adrOverrideId && {ADROverrideID: order.adr.adrOverrideId}),
            CountryCode: order.countryCode,
            Date: order.date,
            DateCancelled: order.dateCancelled,
            DateReturned: order.dateReturned,
            ProductDiscountCode: order.productDiscountCode,
            ShippingDiscountCode: order.shippingDiscountCode,
            CommissionableInPriorMonth: order.commissionableInPriorMonth,
            CommissionedInPriorMonth: order.commissionedInPriorMonth,
            Reason: order.reason,
            Currency: order.currencyCode,
            Status: order.status,
            Type: order.type,
            Category: order.category,
            Channel: order.channel,
            ExternalID: order.externalId,
            GiftReciept: order.giftReceipt, // typo in SalesOrderDetail model
            LineItemDetails: mapLineItemsToSalesOrderDetailLineItems(order.lineItems),
            Shipping: mapShippingToSalesOrderDetailShipping(order),
            SerialNumber: order.serialNumber,
            OrderTotals: mapToOrderTotals(order),
            Payment: mapToSalesOrderPayments(order),
            Pricing: order.pricing,
            Custom: [
                ...(order.eventCode && [{Type: 'EVENT', Key: 'CODE', Value: order.eventCode}] || []),
                ...(order.adr && order.adr.adrContractLength && [{Value: order.adr.adrContractLength, Key: 'ADR_CONTRACT_LENGTH'}] || []),
                ...(order.sender && [{Key: 'SENDER', Value: order.sender}] || []),
                ...(order.shippingPayWithPoints && [{Value: order.shippingPayWithPoints, Key: 'ZZUSE_PTS'}] || []),
                ...(order.microsite && [{Value: order.microsite, Key: 'REASON', Type: 'REASON'}] || [])
            ]
        },
        Messages: mapMessagesToSalesOrder(order.messages),
        TimeStamp: order.timeStamp,
        orderProcessingState: order.orderProcessingState,
        redirectUrl: order.redirectUrl
    };
};

module.exports = toSalesOrderResponse;
